import { useEffect, useMemo, useRef, useState } from "react";
import { avatarBgs } from "./const";
import VoiceCardPlayIcon from "@/assets/common/ic_voice_card_play.svg?react";
import VoiceCardPauseIcon from "@/assets/common/ic_voice_card_pause.svg?react";
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import { getFileDownloadUrl } from "@/services/upload";
import Tooltip from "@/component/Tooltip";

interface SimpleAudioPlayerProps {
  avatarIndex?: number;
  fileKey: string;
  className?: string;
  onAudioChange: (currentAudio: AudioPlayerIns) => void;
  onPlayingChange?: (isPlaying: boolean) => void;
}

const SimpleAudioPlayer: React.FC<SimpleAudioPlayerProps> = ({
  avatarIndex,
  fileKey,
  className,
  onAudioChange,
  onPlayingChange,
}) => {
  const [isPlaying, setPlaying] = useState(false);
  const bg = useMemo(
    () => (avatarIndex !== undefined ? avatarBgs[avatarIndex] : undefined),
    [avatarIndex]
  );
  const myAudio = useRef<AudioPlayerIns | null>(null);

  // 创建一个音频播放器，当卸载时停止播放
  useEffect(() => {
    return () => {
      myAudio.current?.destroy();
      myAudio.current = null;
    };
  }, []);

  // 播放/暂停
  const toggle = async () => {
    if (!myAudio.current) {
      const audioUrl = await getFileDownloadUrl(fileKey);
      const audioPlayerIns: AudioPlayerIns | null = new AudioPlayerIns({
        audioSrc: audioUrl,
        audioDuration: 15,
        onIsPlayingChange: (isPlaying: boolean) => {
          setPlaying(isPlaying);
        },
      });
      myAudio.current = audioPlayerIns;
    }
    myAudio.current?.toggle();
    onPlayingChange && onPlayingChange(!isPlaying);
    // 记录上一个操作的audio，等到下一个操作时，暂停上一个
    onAudioChange(myAudio.current);
  };

  return (
    <Tooltip content={isPlaying? '暂停': '播放'} hover={true}>
      <div
        className={`${className} rounded-[50%] overflow-hidden flex items-center justify-center`}
        style={{
          background: bg,
        }}
      >
        {isPlaying ? (
          <VoiceCardPlayIcon
            className="w-4 h-4 cursor-pointer"
            onClick={toggle}
          />
        ) : (
          <VoiceCardPauseIcon
            className="w-4 h-4 cursor-pointer"
            onClick={toggle}
          />
        )}
      </div>
    </Tooltip>
  );
};

export default SimpleAudioPlayer;
